import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Language } from '@/api/types';
import { LANGUAGE_LABEL, LANGUAGE_SHORT_CODE } from '@/lib/language';
import { LanguageFlag } from '@/components/LanguageFlag';

interface LanguageSwitcherProps {
  value: Language;
  available: Language[];
  onChange: (language: Language) => void;
  inkColor: string;
}

export function LanguageSwitcher({ value, available, onChange, inkColor }: LanguageSwitcherProps) {
  const { t } = useTranslation('applyJob');
  const single = available.length <= 1;

  return (
    <div
      className="relative inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{ background: 'rgba(255,255,255,0.2)', color: inkColor }}
    >
      <LanguageFlag language={value} className="size-4" />
      <span>{LANGUAGE_SHORT_CODE[value] ?? value.toUpperCase()}</span>
      {!single && <ChevronDown className="size-3" aria-hidden />}
      {!single && (
        <select
          aria-label={t('select_language')}
          value={value}
          onChange={(e) => onChange(e.target.value as Language)}
          className="absolute inset-0 cursor-pointer opacity-0"
        >
          {available.map((language) => (
            <option key={language} value={language}>
              {LANGUAGE_LABEL[language]}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
